import React from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Grid2 } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import mail_background from 'src/assets/mail_background.png'
import { ClientServices } from 'src/services/services';
import useAlertStore from 'src/store/useAlertStore';

const ContactsComponent: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showAlert } = useAlertStore();

  const initialValues = {
    name: '',
    email: '',
    company: '',
    number: '',
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(t('CONTACT_FORM_FIELD_NAME_REQUIRED')),
    email: Yup.string().email(t('INVALID_EMAIL')).required(t('CONTACT_FORM_FIELD_EMAIL_REQUIRED')),
    company: Yup.string().required(t('CONTACT_FORM_FIELD_COMPANY_REQUIRED')),
    number: Yup.number()
      .typeError(t('INVALID_NUMBER'))
      .required(t('CONTACT_FORM_FIELD_NUMBER_REQUIRED')),
  });
  
  const handleSubmit = async (values: typeof initialValues, { resetForm }: { resetForm: () => void }) => {
    showAlert(
      'loading',
      t('EMAIL_LOADING'),
      false
    );

    const body = {
      companyName: values.company,
      emailAx: 'info@axeleratum.com',
      email: values.email,
      name: values.name,
      phone: values.number
    };

    setTimeout(async () => {
      await ClientServices.getInstance().postConsultaEmail(body).then(() => {
        showAlert(
          'success',
          t('EMAIL_SENT'),
          true
        );
      }).catch(() => {
        showAlert(
          'failed',
          t('EMAIL_FAILED'),
          true
        );
      });
    }, 1500);
    resetForm();
  };

  return (
    <div className={classes.contactContainer}>
      <Grid2
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          marginTop: '4rem',
          flexWrap: 'nowrap', // Evita que los elementos se apilen
          '@media (max-width: 600px)': {
            flexDirection: 'column', // Cambia a columna en pantallas pequeñas
          },
        }}
      >
        <Grid2 >
          <img
            src={mail_background}
            alt="Kivit Logo"
            className={classes.mailImage}
          />
        </Grid2>

        <Grid2 >
          <div className={classes.formContainer}>
            <h2 className={classes.formTitle}>{t('CONTACT_US')}</h2>
            <p className={classes.formDescription}>{t('CONTACT_US_SUBTITLE')}</p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, touched }) => (
                <Form>
                  <Field
                    as={TextField}
                    name="name"
                    label={t('CONTACT_FORM_FIELD_NAME')}
                    fullWidth
                    margin="normal"
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    className={classes.inputField}
                  />
                  <Field
                    as={TextField}
                    name="email"
                    label={t('CONTACT_FORM_FIELD_EMAIL')}
                    fullWidth
                    margin="normal"
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    className={classes.inputField}
                  />
                  <Field
                    as={TextField}
                    name="company"
                    label={t('CONTACT_FORM_FIELD_COMPANY')}
                    fullWidth
                    margin="normal"
                    multiline
                    error={touched.company && Boolean(errors.company)}
                    helperText={touched.company && errors.company}
                    className={classes.inputField}
                  />
                  <Field
                    as={TextField}
                    name="number"
                    label={t('CONTACT_FORM_FIELD_NUMBER')}
                    fullWidth
                    margin="normal"
                    multiline
                    error={touched.number && Boolean(errors.number)}
                    helperText={touched.number && errors.number}
                    className={classes.inputField}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ marginTop: 2 }}
                  >
                    {t('SEND')}
                  </Button>
                </Form>
              )}
            </Formik>
          </div>
        </Grid2>
      </Grid2>

    </div>
  );
};

export default ContactsComponent;
